// src/api/sku/skuApi.ts
import { axiosInstance } from "src/api/axiosInstance";
import type {
  ApiResponse,
  SkuItem,
  SkuListParams,
  SkuListResponse,
  SkuCreatePayload,
  SkuUpdatePayload,
} from "src/types/sku";

export async function getSkuListApi(params: SkuListParams): Promise<SkuListResponse> {
  const res = await axiosInstance.get<SkuListResponse>("/v1/admin/baseinfo/sku/list", { params });
  return res.data;
}

export async function createSkuApi(payload: SkuCreatePayload): Promise<ApiResponse<SkuItem>> {
  const res = await axiosInstance.post<ApiResponse<SkuItem>>("/v1/admin/baseinfo/sku", payload);
  return res.data;
}

export async function updateSkuApi(payload: SkuUpdatePayload): Promise<ApiResponse<SkuItem>> {
  const res = await axiosInstance.put<ApiResponse<SkuItem>>(`/v1/admin/baseinfo/sku`, payload);
  return res.data;
}

export async function deleteSkuApi(id: number): Promise<ApiResponse<null>> {
  const res = await axiosInstance.delete<ApiResponse<null>>(`/v1/admin/baseinfo/sku/${id}`);
  return res.data;
}
